import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Lane/LaneStatus.requests'

const useCancelLane = ({
    id,
    onSuccess,
}: {
    id: number,
    onSuccess: (...args: any[]) => void,
}) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessLaneStatusUpdate,
        onError,
    } = useHandleStatusRequest({
        title: 'Lane was cancelled',
        id: 'CancelLane',
        onSuccess,
    })

    const {
        mutate: cancel,
    } = useMutation({
        mutationFn: (laneId: number) => {
            return simpleApi({
                ...requests.setAsCancelled({
                    id: laneId,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessLaneStatusUpdate,
    })

    return useCallback(() => {
        cancel(id)
    }, [
        cancel,
        id,
    ])
}

export default useCancelLane
